import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Grid, Typography, units } from '@ha/dsl';

const useStyles = makeStyles(theme => ({
  calendarInfoContainer: {
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: units.rem(1.5),
      paddingRight: units.rem(1.5),
    },
  },
  calendarInfoItem: {
    marginBottom: units.rem(0.5),
  },
}));

interface Props {
  AdditionalInfo?: React.ReactNode;
  minimumPeriodHint?: string;
  moveInWindowsHint?: string;
}

const { Caption } = Typography;

const CalendarInfo: React.FC<Props> = props => {
  const { AdditionalInfo, minimumPeriodHint, moveInWindowsHint } = props;
  const { calendarInfoContainer, calendarInfoItem } = useStyles();

  if (!AdditionalInfo && !minimumPeriodHint && !moveInWindowsHint) {
    return null;
  }

  return (
    <Grid container className={calendarInfoContainer}>
      <Grid
        item
        xs={12}
        className={calendarInfoItem}
        data-test-locator="CalendarInfo / Additional info"
      >
        {AdditionalInfo}
      </Grid>
      <Grid item xs={12} className={calendarInfoItem}>
        <Caption data-test-locator="CalendarInfo / Move-in hint">
          {moveInWindowsHint}
        </Caption>
      </Grid>
      <Grid item xs={12} className={calendarInfoItem}>
        <Caption data-test-locator="CalendarInfo / Minimal period hint">
          {minimumPeriodHint}
        </Caption>
      </Grid>
    </Grid>
  );
};

export default React.memo(CalendarInfo);
